import { formatInTimeZone } from "date-fns-tz";

const ET_ZONE = "America/New_York";

export function formatET(date, formatStr) {
  if (!date) return "";
  return formatInTimeZone(new Date(date), ET_ZONE, formatStr);
}
